/**
 * Mock payload for ClassReport / PrintClassReportPage preview mode.
 * Shape mirrors build_class_report_payload() from backend.
 */
export const mockClassReportPayload = {
  scope: 'class',
  cover: {
    enterprise_name: '前哨科技有限公司',
    class_name: '2026春季创新管理培训班',
    team_avg_score: 67.4,
    // l_grade is an ARRAY matching compute_layer_distribution() output:
    // [{ l_grade, count, pct }, ...] always 4 items (L1-L4)
    l_grade: [
      { l_grade: 'L1', count: 2,  pct: 8.3  },
      { l_grade: 'L2', count: 9,  pct: 37.5 },
      { l_grade: 'L3', count: 11, pct: 45.8 },
      { l_grade: 'L4', count: 2,  pct: 8.3  },
    ],
  },
  dashboard: {
    class: { id: 1, name: '2026春季创新管理培训班' },
    completion: {
      total: 28,
      completed: 24,
      in_progress: 3,
      not_started: 1,
    },
    team_avg_score: 67.4,
    dimension_avgs: [
      { code: 'cognitive_understanding', name: '认知理解力', avg_score: 76.2 },
      { code: 'learning_adaptation',     name: '学习适应力', avg_score: 71.5 },
      { code: 'scenario_judgment',       name: '场景判断力', avg_score: 64.8 },
      { code: 'instruction_interaction', name: '指令交互力', avg_score: 58.3 },
      { code: 'task_orchestration',      name: '任务编排力', avg_score: 52.1 },
      { code: 'result_evaluation',       name: '结果评估力', avg_score: 62.4 },
      { code: 'safety_responsibility',   name: '安全责任力', avg_score: 78.9 },
      { code: 'innovation_transformation', name: '创新转化力', avg_score: 49.6 },
    ],
    score_distribution: [
      { range: '40-49', bucket: '40-49', count: 2 },
      { range: '50-59', bucket: '50-59', count: 5 },
      { range: '60-69', bucket: '60-69', count: 9 },
      { range: '70-79', bucket: '70-79', count: 6 },
      { range: '80-89', bucket: '80-89', count: 2 },
    ],
    layer_distribution: [
      { l_grade: 'L1', count: 2,  pct: 8.3  },
      { l_grade: 'L2', count: 9,  pct: 37.5 },
      { l_grade: 'L3', count: 11, pct: 45.8 },
      { l_grade: 'L4', count: 2,  pct: 8.3  },
    ],
    trait_distribution: [
      { trait_code: 'willingness',    trait_name: 'AI协作意愿', avg: 3.12 },
      { trait_code: 'critical',       trait_name: '独立思考',   avg: 2.60 },
      { trait_code: 'learning',       trait_name: '主动学习',   avg: 2.84 },
    ],
    position_top5: [
      { position: '产品经理', count: 8 },
      { position: '项目经理', count: 6 },
      { position: '研发主管', count: 5 },
      { position: '运营负责人', count: 4 },
      { position: '市场/品牌', count: 3 },
    ],
  },
  heatmap: {
    dimensions: [
      { code: 'cognitive_understanding', name: '认知理解力' },
      { code: 'learning_adaptation',     name: '学习适应力' },
      { code: 'task_orchestration',      name: '任务编排力' },
      { code: 'innovation_transformation', name: '创新转化力' },
    ],
    rows: [
      {
        student: { id: 1, display_name: '张明', position: '产品经理' },
        total_score: 64.8,
        scores: [76, 74, 52, 48],
      },
      {
        student: { id: 2, display_name: '李文静', position: '研发主管' },
        total_score: 63.3,
        scores: [78, 68, 50, 46],
      },
      {
        student: { id: 3, display_name: '王浩宇', position: '项目经理' },
        total_score: 70.3,
        scores: [80, 78, 60, 62],
      },
    ],
    overflow: {
      count: 21,
      team_avg: 67.4,
    },
  },
  risks: {
    summary: {
      scope_kind: 'class',
      total_members: 24,
      affected_members: 3,
      counts_by_register: { '极低': 2, '明显偏低': 1 },
      top_risk_dims: [
        { dim_code: 'innovation_transformation', dim_name: '创新转化力', affected: 14, total: 24 },
        { dim_code: 'task_orchestration',        dim_name: '任务编排力', affected: 11, total: 24 },
        { dim_code: 'instruction_interaction',   dim_name: '指令交互力', affected: 9,  total: 24 },
      ],
      cohort_text_pending: false,
      cache_hit: false,
      generated_at: '2026-05-27T09:14:23Z',
    },
    dimensions: [
      {
        dim_code: 'innovation_transformation', dim_name: '创新转化力', affected: 2, total: 24,
        entries: [
          { student: { id: 2, display_name: '李文静', position: '研发主管' }, score: 36, threshold: 50, register: '极低',
            text: '该员工在创新转化方面明显落后，建议优先关注并制定专项提升计划。' },
          { student: { id: 3, display_name: '王浩宇', position: '项目经理' }, score: 44, threshold: 50, register: '明显偏低',
            text: '该员工创新转化力有待加强，建议参与方法沉淀工作坊。' },
        ],
      },
      {
        dim_code: 'task_orchestration', dim_name: '任务编排力', affected: 1, total: 24,
        entries: [
          { student: { id: 1, display_name: '张明', position: '产品经理' }, score: 38, threshold: 50, register: '极低',
            text: '该员工任务编排力明显不足，建议 1v1 重点干预，补齐人机协同拆解能力。' },
        ],
      },
    ],
  },
  response_quality: {
    flagged_count: 2,
    completed_with_quality: 24,
    missing_quality: 1,
    total_members: 28,
    water_fill_rate: 8.3,
    members: [
      {
        student: { id: 7, display_name: '赵强', position: '运营负责人' },
        level: 'high',
        signals: [
          { code: 'fast_clicking', detail: '30 道计时题中 22 题用时不足 1.5 秒' },
          { code: 'monotone_run', detail: '连续 8 题选择同一分档' },
        ],
        text: '赵强（运营负责人）的作答有效性建议复核：30 道计时题中 22 题用时不足 1.5 秒、连续 8 题选择同一分档。以上为作答行为提示，不代表能力评价。',
      },
      {
        student: { id: 12, display_name: '孙丽', position: '市场/品牌' },
        level: 'low',
        signals: [
          { code: 'monotone_run', detail: '连续 6 题选择同一分档' },
        ],
        text: '孙丽（市场/品牌）的作答有效性建议复核：连续 6 题选择同一分档。以上为作答行为提示，不代表能力评价。',
      },
    ],
  },
  recommendation: {
    class_headline_tag: '"基础认知已就位，但任务编排和创新转化是班级共同瓶颈"',
    class_summary:
      '本班28名成员中，24人已完成测评，团队均分67.4，整体达L3协同优化级。班内学员在认知理解力、学习适应力、安全责任力三个维度表现稳定；但在任务编排力52.1和创新转化力49.6上出现明显塌陷。本报告针对这两个洼地给出具体提升方向。',
    team_weakness: [
      { dim_code: 'innovation_transformation', dim_name: '创新转化力', avg_score: 49.6, affected_count: 14 },
      { dim_code: 'task_orchestration',        dim_name: '任务编排力', avg_score: 52.1, affected_count: 11 },
      { dim_code: 'instruction_interaction',   dim_name: '指令交互力', avg_score: 58.3, affected_count: 9  },
    ],
    recommendations: [
      {
        priority: 'P0',
        title: '建议优先夯实"创新转化力"的方法沉淀与场景拓展',
        affected_count: 14,
        target_dims: ['innovation_transformation'],
        cross_dim_links: ['task_orchestration', 'learning_adaptation'],
        why_priority: '全员触达率最高（58%）且均分最低，是当前最大的能力洼地。',
        improvement_directions: [
          '把已跑通的AI应用案例总结为可复用的方法模板',
          '识别当前业务中还没用AI但应该用的新场景',
          '跨部门分享AI实践成果，形成组织级知识资产',
        ],
        observable_behaviors: '团队会在月度复盘中主动产出2-3个新的AI应用模板。',
        if_skipped_risks: '团队会持续停留在个人英雄主义式的AI应用阶段。',
      },
      {
        priority: 'P0',
        title: '建议补齐"任务编排力"的人机协同拆解能力',
        affected_count: 11,
        target_dims: ['task_orchestration'],
        cross_dim_links: ['instruction_interaction', 'scenario_judgment'],
        why_priority: '班级标准差高达18.4，高低能手并存，差距正在拉大。',
        improvement_directions: [
          '把复杂目标拆解为人做/AI做/协同做三类子任务',
          '设计多步骤AI工作流并在中间环节插入审核点',
        ],
        observable_behaviors: '团队成员开始主动绘制人机协同流程图。',
        if_skipped_risks: '复杂项目交付质量会因为没有任务编排意识出现割裂。',
      },
      {
        priority: 'P1',
        title: '建议提升"指令交互力"的结构化表达水平',
        affected_count: 9,
        target_dims: ['instruction_interaction'],
        cross_dim_links: ['task_orchestration'],
        why_priority: '距65分阈值只差6.7分，相对前两项更接近达标。',
        improvement_directions: [
          '清晰、结构化、含上下文的需求表达',
          '分阶段、可迭代的prompt设计能力',
        ],
        observable_behaviors: '同一个AI工具，团队成员之间产出质量差异显著缩小。',
        if_skipped_risks: '任务编排力的提升效果会打折。',
      },
    ],
    ai_meta: {
      model: 'claude-3-5-sonnet',
      prompt_version: 2,
      tokens_in: 1200,
      tokens_out: 800,
    },
    generated_at: '2026-05-27T09:14:23Z',
    from_cache: false,
  },
};
